<template>
  <div class="summary-card is-orders">
    <div>
      <span>سفارش‌های من</span>
      <strong>{{ totalCount }}</strong>
      <small>سفارش ثبت‌شده</small>
    </div>
    <img src="../../../../public/order.webp" alt="">
  </div>
</template>
<script>
import {mapGetters} from "vuex"

export default {
  name: "my0rders",
  mounted() {
    this.$store.dispatch("ShoppingCart/getOrders")
  },
  computed: {
    ...mapGetters({
      paginationMeta: "ShoppingCart/getPaginationMeta",
    }),
    totalCount() {
      const meta = this.paginationMeta || {}
      return meta.total == null ? 0 : meta.total
    },
  },
}
</script>
<style scoped>
.summary-card {
  position: relative;
  overflow: hidden;
  min-height: 148px;
  border-radius: 20px;
  padding: 20px 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #1e1e1e;
  box-shadow: 0 12px 28px rgba(30, 30, 30, 0.16);
}

.summary-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px),
    linear-gradient(135deg, rgba(235, 61, 96, 0.28), transparent 55%);
  background-size: 12px 12px, auto;
  pointer-events: none;
}

.summary-card > * {
  position: relative;
  z-index: 1;
}

.summary-card span,
.summary-card small {
  display: block;
  opacity: 0.78;
  font-size: 13px;
}

.summary-card strong {
  display: block;
  font-size: 36px;
  line-height: 1.2;
  font-weight: 800;
}

.summary-card img {
  height: 72px;
  width: auto;
  max-width: 38%;
  object-fit: contain;
  opacity: 0.92;
}

.is-orders {
  background: linear-gradient(145deg, #1e1e1e 0%, #2b1a20 100%);
}
</style>
